import React from "react";

const ValidacionTrayectoria = () => {
  const carreras = [
    "Educación Básica",
    "Educación Inicial",
    "Pedagogía Física y Matemática",
    "Pedagogía Química y Biología",
    "Pedagogía Lengua y Literatura",
    "Pedagogía Idiomas",
    "Comunicación",
    "Artes Escénicas",
    "Agronegocios",
    "Gestión Ambiental",
    "Finanzas",
    "Turismo",
    "Contabilidad y Auditoría",
    "Administración de Empresas",
    "Economía",
  ];

  return (
    <div className="card-container">
      <header className="card-header">
        <h2>Validación por ejercicio profesional o experiencia laboral</h2>
        <p className="subtitle">
          Obtén hasta el <strong>70% de reconocimiento</strong> de los
          contenidos de tu carrera gracias a tu trayectoria laboral y avanza más
          rápido hacia tu título.
        </p>
      </header>

      <div></div>

      <section className="card-body">
        <p>
          Titúlate en menos tiempo y reduce el costo de tu carrera validando tu
          experiencia profesional. Realiza un proceso sencillo: nosotros te
          guiamos en cada paso.
        </p>
      </section>

      <div className="button-group margin layout9">
        <button
          className="btn-primary"
          onClick={() =>
            (window.location.href = "https://matriculas.utpl.edu.ec/")
          }
        >
         1. Crear credenciales
        </button>
        <button
          className="btn-primary"
          onClick={() =>
            (window.location.href =
              "https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService")
          }
        >
         2. Solicitar análisis
        </button>

        <button
          className="btn-primary"
          onClick={() =>
            (window.location.href =
              "https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService")
          }
        >
         3. Solicitar reconocimiento
        </button>
      </div>

      <section className="card-body">
        <div className="process-section">
          <h3>Proceso de solicitud:</h3>

          <div className="step-box">
            <h4>1. Crear credenciales institucionales</h4>
            <ul className="sub-step-list">
              <li>
                Haz clic en <strong>Crear credenciales</strong>, registra tus
                datos o accede con Google/Facebook.
              </li>
              <li>
                En <strong>Matrícula</strong> selecciona <strong>Nueva</strong>,
                elige tu carrera, centro universitario y ciclo completo.
              </li>
              <li>
                Ingresa tu identificación (cédula/pasaporte) y selecciona
                Siguiente.
              </li>
              <li>
                <strong>No realices el pago</strong>. Las credenciales llegarán
                a tu correo.
              </li>
            </ul>
          </div>

          <div className="step-box">
            <h4>2. Solicitar análisis</h4>
            <ul className="sub-step-list">
              <li>
                Ingresa con tu usuario y contraseña institucional en{" "}
                <strong>Solicitar análisis</strong>.
              </li>
              <li>
                Ve a <strong>Solicitud de Servicios</strong> {">"}{" "}
                <strong>Servicios-Carrera</strong> {">"}{" "}
                <strong>Solicitar Análisis de validación</strong>.
              </li>
              <li>Adjunta evidencias organizadas por asignatura.</li>
              <li className="price-tag">Costo del servicio: $35.00</li>
            </ul>
            <p className="small-note">
              Una vez enviada la solicitud, nuestro equipo la revisará
              detalladamente. Consulta el estado de la solicitud en el sistema
              institucional, apartado Ver status de la solicitud de servicio.
            </p>
          </div>

          <div className="step-box">
            <h4>3. Solicitar reconocimientos</h4>
            <p className="small-note">Solo si tu solicitud fue aprobada:</p>
            <ul className="sub-step-list">
              <li>
                Ve a <strong>Servicios-Reconocimientos de estudios</strong>{" "}
                {">"}{" "}
                <strong>Solicitar registro de resultados de validación</strong>.
              </li>
              <li>
                Adjunta el <strong>Informe de validación</strong> emitido por la
                carrera.
              </li>
              <li className="price-tag">
                Costo: $35 por asignatura (máximo 10 asignaturas, el resto es
                gratuito).
              </li>
            </ul>
          </div>
        </div>

        <div className="carreras-section">
          <h3>Tecnologías</h3>

        
          <p>
            Conoce más información sobre las tecnologías disponibles para
            validación.
          </p>

          <div className="button-group "> <center> <a
            href="https://utpl.edu.ec/validacion-tecnologias"
            target="_blank"
            rel="noreferrer"
            className="btn-primary"
          >
            Ingresa aquí
          </a> </center> </div>
        
        </div>

        <div className="carreras-section">
          <h3>Carreras disponibles:</h3>
          <p>Conoce las carreras disponibles para validación:</p>
          <ul className="carreras-grid">
            {carreras.map((carrera, index) => (
              <li key={index}>{carrera}</li>
            ))}
          </ul>
        </div>
      </section>

      <footer className="card-footer">
        <h4>¿Necesitas más información?</h4>
        <p>Solicita asesoría virtual en:</p>
        <div className="contact-links">
          <a href="https://utpl.edu.ec/zoom" target="_blank" rel="noreferrer">
            utpl.edu.ec/zoom
          </a>
          <a href="https://wa.me/593999565400" target="_blank" rel="noreferrer">
            WhatsApp: 0999565400
          </a>
        </div>
      </footer>
    </div>
  );
};

export default ValidacionTrayectoria;
